import { CIcon } from '~/icons/types'

export const ciStairs: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22 19.25H6.228v-2.5h2.729a.75.75 0 0 0 .75-.75v-3.25h2.728a.75.75 0 0 0 .75-.75V8.75h2.728a.75.75 0 0 0 .75-.75V4.75H22a.75.75 0 1 0 0-1.5h-5.652a1.221 1.221 0 0 0-1.185 1.25v2.75H12.87a1.22 1.22 0 0 0-1.185 1.25v2.75H9.391a1.22 1.22 0 0 0-1.184 1.25v2.75H5.913a1.22 1.22 0 0 0-1.185 1.25v2.75H2a.75.75 0 1 0 0 1.5h20a.75.75 0 1 0 0-1.5Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'stairs',
  type: 'light'
}
